<app-gmaps [lat]="latitude" [lng]="longitude" [zoom]="15"></app-gmaps>